import { Injectable, Inject, PLATFORM_ID } from "@angular/core";
import { CanActivate, Router, ActivatedRouteSnapshot } from "@angular/router";
import { OrganizationService } from "../services/organization.service";
import { IOrganization } from "../models/IOrganization";
import { isPlatformBrowser } from "@angular/common";
import { map, catchError } from "rxjs/operators";
import { of, Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class HasOrganizationsGuard implements CanActivate {
  constructor(
    private organizationService: OrganizationService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    if (this.organizationService.areUserOrganizationsLoaded) {
      return this.allowOrRedirectToOrganizations(this.organizationService.userOrganizations);
    }

    // Load organizations and check
    return this.organizationService.loadUserOrganizations().pipe(
      map((organizations) => this.allowOrRedirectToOrganizations(organizations)),
      catchError(() => {
        // On error, allow access (don't block user)
        return of(true);
      })
    );
  }

  private allowOrRedirectToOrganizations(organizations: IOrganization[]): boolean {
    if (organizations.length === 0) {
      this.router.navigate(["/dashboard/profile"], {
        queryParams: { tab: "organizations" }
      });
      return false;
    }
    return true;
  }
}
